function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "#adb9ca",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, React.createElement("rect", {
  className: "icon-secondary",
  x: 23.596,
  y: 12.58,
  width: 5.9682,
  height: 14.985,
  strokeWidth: 1.0318
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 5.527,
  y: 15.498,
  width: 6.0647,
  height: 12.116,
  strokeWidth: 0.93527
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 14.588,
  y: 7.5253,
  width: 5.8234,
  height: 19.968,
  strokeWidth: 1.1766
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  stroke: "#002060"
}, React.createElement("path", {
  className: "icon-primary",
  d: "m36.503 23.508-5-4 5-4z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m3.0367 19.508h27.348",
  fill: "none",
  strokeDasharray: "4.00000309 2.99999857",
  strokeMiterlimit: 8
}));

var SvgSurveyModelTabBenchmark = function SvgSurveyModelTabBenchmark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyModelTabBenchmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Survey-Model-Tab-Benchmark.2a3cfe3e.svg";
export { ForwardRef as ReactComponent };